var XPortal = XPortal || {};
XPortal.Navigation = (function () {
    var self = { apps: [], initialized: false };
    self.Init = function (container, options, id) {
        var xself = {};
        xself.id = id ? id : "body";
        options = options ? options : {};
        if (!(self.apps[xself.id])) {
            xself.container = container ? container : "body";
            self.apps[xself.id] = xself;
            xself.sammy = Sammy(xself.container, function () {
                var sapp = this;
                if (options.notFound) sapp.notFound = options.notFound; else sapp.notFound = function () { }; 
                if (options.before)
                    sapp.before('.*', function () {
                        options.before(arguments);
                    });
                sapp.bind('exec-redirect', function (e, data) {
                    this.redirect(data);
                });
            });
        } else xself = self.apps[xself.id];
        if (options.justInit) return xself;

        xself.sammy.run();
        return xself;
    };

    self.MapRoute = function (xpath, xmethod, xverb, xappid) {
        var sapp = self.Init(null, { justInit: true }, xappid);
        xverb = xverb && xverb.length > 0 ? xverb : "any";
        if (xpath && xpath.length)
            sapp.sammy.mapRoutes([[xverb, xpath, xmethod]]);
    };
    self.Redirect = function (xpath, xappid) {
        var sapp = self.Init(null, { justInit: true }, xappid);
        sapp.sammy.trigger('exec-redirect',xpath);
    };
    return self;
})();